import { useEffect, useState } from "react";
import { Roles } from "../../../../../utils/enums";
import { InputModel } from "../../../../../utils/types";
import { Item } from "../../../../../utils/types/generals";
import { removeAllReference } from "../../../../../utils/methods/removedReference";
import { ButtonExecution } from "../components/buttonExecution";
import { Box } from "@mui/material";
import { useContextState } from "../../../../../hooks/theme";

const useInput = ({ items, counter, cleanFilter, getExecutionDetalData, queryv2, lastVersionId, getVersionQuestionaire }: { items?: { [x: string]: Item[] }, counter: number | null, cleanFilter: () => void, getExecutionDetalData: (idversion: string, query?: string) => Promise<void>, queryv2: string, lastVersionId: string, getVersionQuestionaire: (query?: string) => Promise<void> }) => {

  const { colors: color } = useContextState()

  const [input, setInput] = useState<{ [x: string]: InputModel }>({
    /* areas: {
        label: 'general.tags.area',
        translate: true,
        name: 'areas',
        type: 'filter-select',
        items: items?.areas ?? [],
        value: null,
        size: {
          xl: 3,
          lg: 3,
          md: 3,
          sm: 6,
          xs: 12, 
        },
    },
    departments: {
        label: 'general.tags.department',
        translate: true,
        name: 'departments',
        type: 'filter-select',
        items: items?.departments ?? [],
        value: null,
        size: {
          xl: 3,
          lg: 3,
          md: 3,
          sm: 6,
          xs: 12, 
        },
    }, */
    divisions: {
      label: 'general.tags.division',
      translate: true,
      name: 'divisions',
      type: 'filter-select',
      items: items?.divisions ?? [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    zoneId: {
      label: 'general.tags.zone',
      translate: true,
      name: 'zoneId',
      type: 'filter-select',
      items: items?.zoneId ?? [],
      value: [],
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    childZone: {
      label: 'general.tags.class',
      translate: true,
      name: 'childZone',
      type: 'filter-select',
      items: items?.childZone ?? [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    keyCodeId: {
      label: 'general.tags.idStore',
      translate: true,
      name: 'keyCodeId',
      type: 'filter-select',
      items: items?.keyCodeId ?? [],
      value: [],
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    userTypeId: {
      label: 'general.tags.userType',
      translate: true,
      name: 'userTypeId',
      type: 'filter-select',
      items: items?.userTypeId ?? [],
      value: [],
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    userId: {
      label: 'general.tags.user',
      translate: true,
      name: 'userId',
      type: 'filter-select',
      items: items?.userId ?? [],
      value: [],
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    from: {
      label: 'general.tags.from',
      translate: true,
      name: 'from',
      type: 'date',
      value: null,
      rest: {
        max: 'to',
      },
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    to: {
      label: 'general.tags.to',
      translate: true,
      name: 'to',
      type: 'date',
      value: null,
      rest: {
        min: 'from',
      },
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
      /* wrapChildren: ({children,id})=>{
        
        return(
          <ButtonExecution children={children} id={id} counter={counter} cleanFilter={cleanFilter} getExecutionDetalData={getExecutionDetalData} queryv2={queryv2} lastVersionId={lastVersionId} getVersionQuestionaire={getVersionQuestionaire}/>
        )
      } */
    },
    status: {
      label: 'general.tags.status',
      translate: true,
      name: 'status',
      type: 'filter-select',
      items: items?.status ?? [],
      value: null,
      size: {
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12,
      },
    },
    answerType: {
      label: 'general.tags.answerType',
      translate: true,
      name: 'answerType',
      type: 'select-search',
      items: [],
      value: [],
      size: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12,
      },
      wrapChildren: ({ children, id }) => {

        return (
          <ButtonExecution children={children} id={id} counter={counter} cleanFilter={cleanFilter} getExecutionDetalData={getExecutionDetalData} queryv2={queryv2} lastVersionId={lastVersionId} getVersionQuestionaire={getVersionQuestionaire} />
        )
      }
    },

  })

  const disabledInputs = (data: { inputs: string[]; value: boolean }) => {
    let copyInput: {
      [x: string]: InputModel
    } = removeAllReference(input)

    data?.inputs?.forEach((item) => {
      copyInput[item] = {
        ...copyInput[item],
        rest: {
          ...(copyInput[item]?.rest ?? {}),
          disabled: data.value,
        },
      }
    })

    setInput((prev) => ({
      ...prev,
      ...copyInput,
    }))
  }

  useEffect(() => {

    let body = {};
    Object.entries(input).forEach(([key, itemInputs]) => {
      body = { ...body, [key]: { ...itemInputs, items: items?.[key] } };
    });

    setInput(body);
  }, [items]);

  useEffect(() => {
    setInput((prevInput) => {
      let newInput = { ...prevInput };
      newInput.answerType.wrapChildren = ({ children, id }) => (
        <ButtonExecution children={children} id={id} counter={counter} cleanFilter={cleanFilter} getExecutionDetalData={getExecutionDetalData} queryv2={queryv2} lastVersionId={lastVersionId} getVersionQuestionaire={getVersionQuestionaire} />
      );
      return newInput;
    });
  }, [counter, queryv2, lastVersionId]);

  return { input, disabledInputs }
}

export { useInput }